var CompanySize = {
	"Company size": "Tamanho da empresa",
	"1-19 employees": "1-19 employees (1 a 19 funcionários)",
	"20-99 employees": "20-99 employees (20 a 99 funcionários)",
	"100-499 employees": "100-499 employees (100 a 499 funcionários)",
	"500-999 employees": "500-999 employees (500 a 999 funcionários)",
	"1,000-9,999 employees": "1,000-9,999 employees (1.000 a 9.999 funcionários)",
	"10,000 employees or more": "10,000 employees or more (10.000 funcionários ou mais)"
};

export { CompanySize as default };
